import { render, staticRenderFns } from "./LexinKeyboardLangAra.vue?vue&type=template&id=8d5cc246&"
import script from "./LexinKeyboardLangAra.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangAra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports